<template>
  <div>
    <obituary-letter
      :obituaryMessages="obituaryMessages"
      @handleViewLetter="letterListFlag = true"
      @handleRegistLetter="letterListFlag = 'regist'"
      @handleEditFlag="handleEditFlag"
    />

    <obituary-msg-list
      v-if="letterListFlag"
      :letterListFlag="letterListFlag"
      :obituary-msg="obituaryMessages"
      @close="letterListFlag = false"
      @handleEditFlag="handleEditFlag"
    />

    <v-bottom-sheet v-model="passwordFlag" inset>
      <v-sheet height="auto">
        <div class="bottom-modal__wrap">
          <div class="pb-4">
            <h4>등록 시 입력한 비밀번호를 입력하세요</h4>
          </div>
          <div class="bottom-modal__content">
            <v-text-field
              v-model="messagePassword"
              hide-details
              outlined
              dense
              type="password"
              color="main"
              placeholder="등록 시 사용한 비밀번호를 입력"
              @keyup.enter="handleCheckPassword"
            ></v-text-field>
          </div>
          <div class="bottom-modal-button__wrap">
            <div class="bottom-modal-button close" @click="handleEditInit">
              닫기
            </div>
            <div class="bottom-modal-button apply" @click="handleCheckPassword">
              확인
            </div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="editCommentFlag" inset>
      <v-sheet height="auto">
        <div class="bottom-modal__wrap">
          <div
            class="pb-4"
            style="display: flex; justify-content: space-between"
          >
            <h4 class="edit-msg__title">추모의 글 수정</h4>
            <button class="delete-msg" @click="handleDeleteObituaryComment">
              삭제
            </button>
          </div>

          <h6>보내는 분</h6>
          <v-text-field
            v-model="targetObituaryComment.messageName"
            outlined
            dense
            hide-details
            type="text"
            color="main"
            placeholder="성함을 입력하세요"
          ></v-text-field>
          <h6 class="pt-2">비밀번호</h6>
          <v-text-field
            v-model="targetObituaryComment.messagePassword"
            hide-details
            outlined
            dense
            :type="passwordFieldType"
            color="main"
            placeholder="수정 시 사용할 비밀번호를 입력"
            append-icon="mdi-eye"
            @click:append="passwordVisible = !passwordVisible"
          ></v-text-field>
          <h6 class="pt-2">추모 메시지</h6>
          <v-textarea
            v-model="targetObituaryComment.messageContent"
            outlined
            height="218px"
            counter="100"
            color="main"
            placeholder="삼가 고인의 명복을 빕니다"
          ></v-textarea>

          <div class="bottom-modal-button__wrap">
            <div class="bottom-modal-button close" @click="handleEditInit">
              닫기
            </div>
            <div
              class="bottom-modal-button apply"
              @click="handleEditObituaryComment"
            >
              저장
            </div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import ObituaryMsgList from "./ObituaryMsgList.vue";
import ObituaryLetter from "./ObituaryLetter.vue";
export default {
  name: "ObituaryMessage",
  components: { ObituaryLetter, ObituaryMsgList },
  props: ["obituaryDetail"],

  data() {
    return {
      letterListFlag: false,
      targetObituaryComment: {
        messageName: "",
        messageContent: "",
        messagePassword: ""
      },

      passwordFlag: false,
      editCommentFlag: false,

      messagePassword: "",
      passwordVisible: false
    };
  },

  computed: {
    obituaryMessages() {
      return this.obituaryDetail?.ObituaryMessages;
    },
    passwordFieldType() {
      return this.passwordVisible ? "text" : "password";
    }
  },
  methods: {
    handleEditFlag(obituaryComment) {
      this.targetObituaryComment = obituaryComment;
      this.passwordFlag = true;
    },

    handleEditInit() {
      this.targetObituaryComment = {
        messageName: "",
        messagePassword: "",
        messageContent: ""
      };

      this.messagePassword = "";
      this.passwordFlag = false;
      this.editCommentFlag = false;
    },

    async handleCheckPassword() {
      if (this.messagePassword) {
        await this.$store
          .dispatch(`REQUEST_OBITUARY_MSG_PWD_CHECK`, {
            messagePassword: this.messagePassword,
            id: this.targetObituaryComment.id
          })
          .then(data => {
            // const result = data.result;
            if (!data) return;

            this.editCommentFlag = true;
            this.targetObituaryComment.messagePassword = this.messagePassword;
            this.messagePassword = "";
            this.passwordFlag = false;
          });
      }
    },

    async handleEditObituaryComment() {
      try {
        const {
          id,
          messageName,
          messagePassword,
          messageContent,
          ObituaryId,
          OBM_GRP
        } = this.targetObituaryComment;

        console.log(this.targetObituaryComment);

        if (!messageName) {
          return alert("성함을 입력하여 주십시요");
        }

        if (!messagePassword.trim()) {
          return alert("비밀번호를 입력하여 주십시요");
        }
        if (!messageContent) {
          return alert("내용을 입력하여 주십시요");
        }

        if (messageContent.length > 100) {
          alert("추모 메시지는 100자를 초과할 수 없습니다.");
          return;
        }

        const parameter = {
          messageId: id,
          ObituaryId,
          messageName,
          messageContent,
          messagePassword,
          OBM_GRP
        };

        await this.$store
          .dispatch(`REQUEST_OBITUARY_MSG_SEND`, parameter)
          .then(data => {
            if (!data) return;

            this.handleEditInit();
          });
      } catch (error) {
        console.error(error);
      }
    },

    async handleDeleteObituaryComment() {
      const { id, ObituaryId } = this.targetObituaryComment;

      if (confirm("해당 추모 메시지를 삭제하시겠습니까?")) {
        const parameter = {
          messageId: id,
          ObituaryId
        };
        this.$store
          .dispatch("REQUEST_DELETE_OBITUARY_COMMENT", parameter)
          .then(res => {
            if (!res) return;

            alert("삭제 되었습니다.");

            this.$router.go();
          });
      }
    }
  }
};
</script>

<style></style>
